// @flow
/* eslint-disable no-param-reassign */
import axios from 'axios'
import type { AxiosXHRConfig } from 'axios'
import { camelize } from 'utils/camelize'
// import { UserService } from 'services/user'

/**
 * Перехватчик на выполнение запроса
 * @param {*} config
 */
// flowlint-next-line unclear-type:off
export function RequestInterceptor(config: AxiosXHRConfig<any> & { camelize?: boolean, ... }) {
  const convert = typeof config.camelize === 'boolean' ? config.camelize : true

  config.headers = {
    'Content-Type': 'application/json',
    ...config.headers,
  }

  if (convert) {
    const defaultTransform = axios.defaults.transformResponse

    const camelizeResponse = (data) => {
      return camelize(data)
    }

    // $FlowFixMe[incompatible-use]
    config.transformResponse = Array.isArray(defaultTransform)
      ? [...defaultTransform, camelizeResponse]
      : [defaultTransform, camelizeResponse]
  }

  return config
}
